import React from 'react'
import ModalLeft from './Highlights/Highlights'
import ModalRight from './Details/InfoContainer'

const BrewDetail: React.FC = () => {
    return (
        <div className='brewdetail flex justify-between w-full h-full overflow-y-auto rounded-lg'>
            <div className='bg-gray-50 lg:sticky lg:top-0 lg:block hidden w-3/6 rounded-l-lg'>
                <ModalLeft />
            </div>
            <div className='lg:rounded-r-lg w-full h-full bg-white rounded-lg'>
                <ModalRight />
            </div>
        </div>
    )
}

export default BrewDetail
